import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import PowerfulCompliment from './components/PowerfulCompliment'
import ComposablePlatform from './components/ComposablePlatform'
import Octopus from './components/Octopus'
import MoveQuickly from './components/MoveQuickly/MoveQuickly'

import ogImagePng from './assets/OgComposableCdp.png'

const ComposableCdpView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Segment's composable CDP | Twilio Segment"
        pageDescription="Segment’s composable platform is open, easy to use, and integrated with all your favorite applications."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.cloud[100]}
      >
        <Navigation />
        <Main>
          <Hero />
          <LogoCarousel />
          <PowerfulCompliment />
          <ComposablePlatform />
          <Octopus />
          <MoveQuickly />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default ComposableCdpView

const Main = styled.main``
